import { Nowrap } from '@farmersdog/corgi-x';

type VetTestimonialItem = {
  author: string;
  quote: JSX.Element | string;
};

export const vetTestimonialItems: VetTestimonialItem[] = [
  {
    author: 'Madison Phillips, DVM',
    quote: (
      <>
        Since switching to <Nowrap>The Farmer’s Dog</Nowrap>, I’ve noticed my
        dogs’ poops look healthy, and they are so excited for their meals! I
        couldn’t be happier knowing they’re eating nutritious food which gives
        me peace of mind as a vet and a <Nowrap>dog mom</Nowrap>.
      </>
    ),
  },
  {
    author: 'Cynthia Pacelli, Head Technician',
    quote: (
      <>
        I was nervous to try something new, but{' '}
        <Nowrap>The Farmer’s Dog</Nowrap> has made a huge difference in Nero’s
        life and care. He’s happier, excited to eat, and healthier{' '}
        <Nowrap>than ever!</Nowrap>
      </>
    ),
  },
  {
    author: 'Sarah Callahan, DVM',
    quote: (
      <>
        I very much approach health recommendations with a ‘food is medicine’
        philosophy and <Nowrap>The Farmer’s Dog</Nowrap> solved the challenges I
        was experiencing with home cooked options. It’s made the process so much
        more convenient than <Nowrap>home cooking!</Nowrap>
      </>
    ),
  },
];
